export type Campos = {
  name: string;
  show: string;
  validate?: (value: string, values?: string[]) => undefined | ErrorDTO[];
  transform?: (value: string, values?: string[]) => any;
  showTransformed?: (valueOrigin: string, valueTransformed: any) => string;
}

export type ImportActions = 'INS' | 'UPD' | 'NONE' | ImportActionsMS;
export enum ImportActionsMS
{
  INS = 0,
  UPD = 1,
  NONE = 2,
}

export type ImportStatusRow = {
  action: ImportActions;
  //¿scripts de implementación y rollback?

  /** script a ejecutar para importar el registro */
  script?: string;

  /** script a ejecutar para realizar el rollback */
  rollback?: string;
}

export type ImportConfig = {
  /** Campos a importar en el orden que deben estar en el archivo */
  fields: Campos[];

  /**
   * Devuelve la acción a realizar
   * @param values valores ya procesados
   * @param isTest indica si se está testeando
   */
  getAction: (values: any[], isTest: boolean) => Promise<ImportStatusRow>;

  /** ocurre cuando se termina de importar toda la información */
  onPostEjecutarImportacion?: (info: ImportResultFinal, user: any) => Promise<any>;
}

export type ErrorDTO = {
  error?: string; // error, si ocurrió uno
  warn?: string; // warning, si ocurrió uno
  params?: any;  // parámetros para mostrar el error
}

export type DataDTO = {
  /** dato en crudo */
  original?: string;

  /** valor final */
  valor?: any;

  /** valor a mostrar en pantalla (si no se especifica, mostrar campo "valor") */
  show?: string;
}

export type ImportResult = {
  /** Acción a realizar */
  action?: ImportStatusRow;

  /** número de Row */
  index: number; 

  /** datos en crudo */
  row: string;

  /** mensajes de error y warnings */
  errors: ErrorDTO[];

  /** Valores finales procesados */
  data?: DataDTO[];
}

export type ImportResultFinal = {
  /** Entidad a Importar */
  entity: string;

  /** Resultados row x row */
  results: ImportResult[]; 

  /** Campos a importar */
  fields: string[];

  /** ocurre cuando se termina de importar toda la información */
  onPostEjecutarImportacion?: (info: ImportResultFinal, user: any) => Promise<any>;
}


export type ImportFinal = {
  /** Entidad a Importar */
  entity: string;

  inserteds: number;
  updateds: number;
}


export type ImportacionDTO = {
  id?: number;
  entity?: string;
  creafecha?: Date;
  creausulogin?: string;
  scriptfecha?: Date;
  rollbackfecha?: Date;
  rollbackusulogin?: string;
}